import styled from 'styled-components';
import View from './View';
export default styled(View)`
  flex-direction: row;
  flex-shrink: 0;
`;
